import React from 'react'
import CardSetHeader from '../cardSetHeader'

export default function AllTitle(props) {
    return (
        <CardSetHeader
            title={"All Stores " + props.revenueCommission.substring(0,1).toUpperCase() + props.revenueCommission.substring(1)}
            onAddHidden={props.onAddHidden}
            setName={props.setName}
        />
    )
}